import { useMemo } from 'react';
import { useAssignableMembers } from '../../../../hooks/useRoles';
import type { ListFilterSummary } from '../../shared/listFilterSummary';
import { useSharedFilterSources } from '../../shared/useSharedFilterSources';
import type { NotificationListParams } from '../notificationListParams';
import { notificationListSummary } from '../notificationListSummary';

export function useNotificationListSummary(
    listParams: NotificationListParams,
    total: number | null
): ListFilterSummary {
    const { levels, tags, status, sort, order } = listParams;
    const { members: people } = useAssignableMembers();
    const shared = useSharedFilterSources(listParams, people);
    return useMemo(
        () => notificationListSummary({ shared, levels, tags, status, sort, order, total }),
        [shared, levels, tags, status, sort, order, total]
    );
}
